import EventEmitter from 'events'

// 'loggedIn' is used in other parts of application. So, Don't forget to change there also
const loggedInKey = 'loggedIn'
const accessTokenKey = 'accessToken'
const refreshTokenKey = 'refreshToken'
const userInfoKey = 'userInfo'
const loginEvent = 'loginEvent'


class AuthService extends EventEmitter {

  localLogin(commit, authResult) {
    localStorage.setItem(loggedInKey, true)
    localStorage.setItem(accessTokenKey, authResult.bearerToken)
      // Set bearer token in axios
    commit('SET_BEARER', authResult.bearerToken)

    if (!authResult.refreshToken) {
      return
    }

    localStorage.setItem(refreshTokenKey, authResult.refreshToken)

    // Update user details
    const userData = {
      uid: authResult.userId,
      displayName: authResult.displayName,
      photoURL: authResult.profileUrl,
      email: authResult.userName,
      phoneNumber: null
    }
    commit('UPDATE_USER_INFO', userData, { root: true })


    this.emit(loginEvent, {
      loggedIn: true,
      profile: userData,
      state: authResult.appState || {}
    })
  }

  logout() {
    localStorage.removeItem(loggedInKey)
    localStorage.removeItem(userInfoKey)
    localStorage.removeItem(accessTokenKey)
    localStorage.removeItem(refreshTokenKey)
    this.emit(loginEvent, { loggedIn: false })
  }

  isAuthenticated() {
    return (
      localStorage.getItem(loggedInKey) === 'true'
    )
  }
}

export default new AuthService()
